export const AMOUNTS = {
  amountMin: 1_000,
  amountMax: 15_000_000,
  initialFeeMin: 0,
  initialFeeMax: 15_000_000,
  monthlySalaryMin: 20_000,
  monthlySalaryMax: 10_000_000,
  additionalIncomeMin: 0,
  additionalIncomeMax: 10_000_000,
  loanPaymentsMin: 0,
  loanPaymentsMax: 10_000_000,
  loansSvcRequestDefault: 300_000,
  defaultFormValue: 500_000,
  defaultVitrinsCardLimit: 150_000,
  minVitrinsCardLimit: 1_000,
  maxVitrinsCardLimit: 1_000_000,
};
